import { Icon } from '@iconify/react';

// Admin Pages
import AdminDashboard from '../pages/admin/Dashboard';
import AdminClients from '../pages/admin/Clients';
import AdminActivity from '../pages/admin/Activity';
import AdminSecurity from '../pages/admin/Security';
import AdminAdvanced from '../pages/admin/Advanced';
import CustomerBootstrap from '../pages/admin/CustomerBootstrap';
import AlertsPage from '../pages/AlertsPage';
import AndyNotesPage from '../pages/admin/AndyNotes';

import AdminAlerts from '../pages/admin/Alerts';
import AdminEquipmentReview from '../pages/admin/EquipmentReview';
import AdminPolicyReview from '../pages/admin/PolicyReview';
import TokenMetrics from '../pages/admin/TokenMetrics';

import VoiceChatInterface from '../components/chat/VoiceChatInterface';

// Voice AI Pages
import CallHistory from '../pages/categories/voiceAI/CallHistory';
import Insights from '../pages/categories/voiceAI/Insights';
import Orders from '../pages/clients/wards/Orders';
import Inventory from '../pages/clients/wards/Inventory';
import EquipmentPolicies from '../pages/clients/wards/EquipmentPolicies';
import TicketsPage from '../pages/general/Tickets';

// Kronk Pages
import KronkOrders from '../pages/clients/kronk/Orders';
import FAQs from '../pages/clients/kronk/FAQs';

// Chat AI Pages
import ChatHistory from '../pages/categories/chatAI/ChatHistory';

// Client Pages
import WardsHome from '../pages/clients/wards/WardsHome';
import ScaleHome from '../pages/clients/scale/ScaleHome';
import KokoroHome from '../pages/clients/kokoro/KokoroHome';
import KronkHome from '../pages/clients/kronk/KronkHome';
import GamedayHome from '../pages/clients/gameday/GamedayHome';
import CelesteHome from '../pages/clients/celeste/CelesteHome';
import StateSealHome from '../pages/clients/stateseal/StateSealHome';

// General Pages
import UserSettings from '../pages/general/UserSettings';
import HelpPage from '../pages/general/HelpPage';
import ChatInterface from '../pages/general/ChatInterface';

export const pageCategories = {
    ADMIN: 'admin',
    COMMON: 'common',
    VOICE_AI: 'voiceAI',
    REMEMBRANCE_AI: 'remembranceAI',
    CHAT_AI: 'chatAI',
    STATESSEAL: 'stateseal_specific',
    // Add other categories as needed
};

export const allPages = {
    // Check if I have to add an ID if path is not a key identifier
    // ADMIN PAGES
    adminDashboard: { path: 'admin-dashboard', title: 'Dashboard', icon: "material-symbols:dashboard-rounded", category: pageCategories.ADMIN, element: <AdminDashboard /> },
    adminClients: { path: 'admin-clients', title: 'Clients', icon: "fluent:organization-16-filled", category: pageCategories.ADMIN, element: <AdminClients /> },
    adminActivity: { path: 'admin-activity', title: 'Activity', icon: "hugeicons:activity-04", category: pageCategories.ADMIN, element: <AdminActivity /> },
    adminAdvanced: { path: 'admin-advanced', title: 'Advanced', icon: "rivet-icons:gears", category: pageCategories.ADMIN, element: <AdminAdvanced /> },
    customerBootstrap: { path: 'customer-bootstrap', title: 'Customer Bootstrap', icon: "mdi:domain-plus", category: pageCategories.ADMIN, element: <CustomerBootstrap /> },
    // Update route once you confirm differentiation from Admin-Alerts and AlertsPage
    adminAlerts: { path: 'alerts', title: 'Monitoring', icon: "lucide:monitor-cog", category: pageCategories.ADMIN, element: <AdminAlerts /> },
    andyNotes: { path: 'andy-notes', title: 'Andy Notes', icon: "material-symbols:note-alt-rounded", category: pageCategories.ADMIN, element: <AndyNotesPage /> },
    equipmentReview: { path: 'equipment-review', title: 'Inventory Changes', icon: "material-symbols:rate-review-rounded", category: pageCategories.ADMIN, element: <AdminEquipmentReview /> },
    policyReview: { path: 'policy-review', title: 'Policy Changes', icon: "iconoir:privacy-policy", category: pageCategories.ADMIN, element: <AdminPolicyReview /> },
    tokenMetrics: { path: 'token-metrics', title: 'Token Metrics', icon: "material-symbols:token-outline", category: pageCategories.ADMIN, element: <TokenMetrics /> },

    // Client: Celeste
    celesteHome: { path: 'celeste-home', title: 'Home', icon: "material-symbols:home-rounded", category: 'celeste_specific', element: <CelesteHome /> },

    // Client: Ward's Rental
    wardsHome: { path: 'wards-home', title: 'Home', icon: "material-symbols:home-rounded", category: 'wards_specific', element: <WardsHome /> },
    orders: { path: 'orders', title: 'Orders', icon: "material-symbols:order-approve-outline", category: 'wards_specific', element: <Orders /> },
    inventory: { path: 'inventory', title: 'Inventory', icon: "lsicon:inventory-filled", category: 'wards_specific', element: <Inventory /> },
    equipmentPolicies: { path: 'equipment-policies', title: 'Equipment Policies', icon: "iconoir:privacy-policy", category: 'wards_specific', element: <EquipmentPolicies /> },

    // Client: Scale
    scaleHome: { path: 'scale-home', title: 'Home', icon: "material-symbols:home-rounded", category: 'scale_specific', element: <ScaleHome /> },

    // Client: Kokoro
    kokoroHome: { path: 'kokoro-home', title: 'Home', icon: "material-symbols:home-rounded", category: 'kokoro_specific', element: <KokoroHome /> },

    // Client: Kronk
    kronkHome: { path: 'kronk-home', title: 'Home', icon: "material-symbols:home-rounded", category: 'kronk_specific', element: <KronkHome /> },
    kronkOrders: { path: 'kronk-orders', title: 'Orders', icon: "material-symbols:order-approve-outline", category: 'kronk_specific', element: <KronkOrders /> },
    faqs: { path: 'faqs', title: 'Knowledge Base', icon: "material-symbols:help-outline", category: 'kronk_specific', element: <FAQs /> },

    // Client: Gameday
    gamedayHome: { path: 'gameday-home', title: 'Home', icon: "material-symbols:home-rounded", category: 'gameday_specific', element: <GamedayHome /> },

    // Client: State Seal
    stateSealHome: { path: 'stateseal-home', title: 'Dashboard', icon: "material-symbols:home-rounded", category: pageCategories.STATESSEAL, element: <StateSealHome /> },

    // COMMON PAGES
    
    // Add tickets post Client Auth
    tickets: { path: 'tickets', title: 'Tickets', icon: "f7:tickets", category: pageCategories.COMMON, element: <TicketsPage /> },
    
    // Profile-only pages (not shown in navigation)
    settings: { path: 'settings', title: 'Settings', icon: "material-symbols:settings-outline-rounded", category: 'profile-only', element: <UserSettings /> },
    help: { path: 'help', title: 'Help', icon: "material-symbols:help-outline-rounded", category: 'profile-only', element: <HelpPage /> },

    // VOICE AI CATEGORY
    callLogs: { path: 'calls', title: 'Call History', icon: "material-symbols-light:call-log", category: pageCategories.VOICE_AI, element: <CallHistory /> },
    insights: { path: 'insights', title: 'Insights', icon: "proicons:graph", category: pageCategories.VOICE_AI, element: <Insights /> },
    chat: { path: 'chat', title: 'Voice Chat', icon: "material-symbols:voice-chat-outline-rounded", category: pageCategories.VOICE_AI, element: <VoiceChatInterface /> },
    
    // CHAT AI CATEGORY
    chatHistory: { path: 'chat-history', title: 'Chat History', icon: "ph:chats-fill", category: pageCategories.CHAT_AI, element: <ChatHistory /> },
    // insights: { path: 'insights', title: 'Insights', icon: "proicons:graph", category: pageCategories.CHAT_AI, element: <Insights /> },

    // REMEMBRANCE AI CATEGORY
    // Add Remembrance AI pages here
    testing: { path: 'testing', title: 'Testing', icon: "grommet-icons:test", category: pageCategories.REMEMBRANCE_AI, element: <div>Testing</div> },    
};

export const customerConfig = {
  helios: {
    category: pageCategories.VOICE_AI,
    include: ['celeste-home'],
    exclude: []
  },
  // 'wards' is a voiceAI customer, but gets a specific page and has an exception.
  wards: {
    category: pageCategories.VOICE_AI,
    include: ['wards-home', 'orders', 'inventory', 'equipment-policies', 'insights'], // Include the customer-specific 'wards-home' and 'orders' pages
    // Comment this line after testing
    exclude: [] // Exclude the 'insights' page, even though it's in their category
  },
  // another_customer might just be a standard voiceAI client
  kokoro: {
    category: pageCategories.REMEMBRANCE_AI,
    include: ['kokoro-home', 'insights'],
    exclude: []
  },
  scale: {
    category: pageCategories.VOICE_AI,
    include: ['scale-home', 'insights'],
    exclude: []
  },
  kronk: {
    category: pageCategories.CHAT_AI,
    include: ['kronk-home', 'insights', 'kronk-orders', 'faqs'], // Include the 'kronk-orders' and 'faqs' pages
    exclude: []
  },
  gameday: {
    category: pageCategories.VOICE_AI,
    include: ['gameday-home', 'insights'],
    exclude: []
  },
  stateseal: {
    category: pageCategories.STATESSEAL,
    include: ['stateseal-home'],
    exclude: []
  },
  // Default for any other customer
  default: {
    category: pageCategories.COMMON,
    include: [],
    exclude: []
  }
};